import React from "react"
import { formTranslation } from "../../../locales/form"
import ValidatableInput from "../../ValidatableInput/ValidatableInput"
import { SlotType } from "../../../models/slot"
import { useTranslation } from "react-i18next"
import { useSlots } from "../../../hooks/useSlots"

interface Props {
    id: string
    name: string
    label: string
    type?: SlotType
    icon?: JSX.Element
}

const SlotSelectControl: React.FC<Props> = props => {
    const { type, ...inputProps } = props
    const { slots } = useSlots()
    const { t } = useTranslation()

    const filteredSlots = type ? slots.filter(s => s.Type === type) : slots

    return (
        <ValidatableInput as="select" disabled={!filteredSlots.length} {...inputProps}>
            <option value="">{t(formTranslation.nothingSelected)}</option>
            {filteredSlots.map(({ Id, Title, ExternalId }) => (
                <option value={ExternalId} key={Id}>
                    {`${Title}`}
                </option>
            ))}
        </ValidatableInput>
    )
}

export default SlotSelectControl
